import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { JsonLd, faqSchema } from "@/components/StructuredData";

export default function FAQAccordion({ faqs = [], title = "Frequently Asked Questions" }) {
  if (!faqs.length) return null;
  return (
    <section className="container-wide py-16" data-testid="faq-section">
      <JsonLd data={faqSchema(faqs)} />
      <div className="max-w-3xl">
        <div className="text-xs uppercase tracking-widest text-accent mb-3">Questions</div>
        <h2 className="font-serif text-3xl sm:text-4xl text-foreground mb-8">{title}</h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="text-left text-base font-medium">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-foreground/75 leading-7 text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
